import UserCard from './UserCardContainer'


export default UserCard